import { getImpersonatedUserId, stopImpersonating } from '../auth/impersonation';
import usePermissions from '../hooks/usePermissions';
import './ImpersonationBar.css';

// Across the top of every page while an admin views the app as someone else.
export default function ImpersonationBar() {
  const { user, impersonatedBy } = usePermissions();

  if (!getImpersonatedUserId()) return null;

  return (
    <div className="ppc-impersonation-bar" role="status">
      <i className="bi bi-eye" aria-hidden="true" />
      <span className="ppc-impersonation-bar__text">
        Viewing as <strong>{user?.name || '…'}</strong>
        {impersonatedBy?.name ? <span className="ppc-impersonation-bar__by"> (signed in as {impersonatedBy.name})</span> : null}
      </span>
      <button type="button" className="ppc-impersonation-bar__stop" onClick={stopImpersonating}>
        Stop
      </button>
    </div>
  );
}
